import classNames from "classnames";
import { useEffect, useRef } from "react";
export function Checkbox(_a) {
    var checked = _a.checked, className = _a.className, onChange = _a.onChange, onKeyDown = _a.onKeyDown, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.id, id = _c === void 0 ? undefined : _c;
    var inputRef = useRef(null);
    var isIndeterminate = checked === "indeterminate";
    useEffect(function () {
        if (inputRef.current !== null) {
            inputRef.current.indeterminate = isIndeterminate;
        }
    }, [isIndeterminate]);
    var checkedBool = checked === "indeterminate" ? false : checked;
    return (<input id={id} ref={inputRef} tabIndex={0} type="checkbox" className={classNames("size-3.5 form-checkbox enabled:cursor-pointer rounded disabled:opacity-50 enabled:hover:text-content-link enabled:hover:outline enabled:hover:outline-content-primary", "focus:outline-0 focus:ring-0", "bg-background-secondary ring-offset-background-secondary checked:bg-util-accent text-util-accent", className)} onChange={onChange} onKeyDown={function (event) {
            if (event.key === "Enter") {
                onChange(event);
                return;
            }
            onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
        }} disabled={disabled !== null && disabled !== void 0 ? disabled : false} checked={checkedBool} aria-checked={checkedBool} aria-label="Selected"/>);
}
